import { put, call } from 'redux-saga/effects';
import { authManager } from '../../../../core/managers';
import { Types } from './actions';
import { Types as TypesProfile } from '../../getProfile/actions';
import ProfileRepository from '../../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../../data/repositories/ProfileDataRepository';
import { KeycloakManager } from '../../../../core/managers/keycloakManager';

async function deleteCredentials() {
  await authManager.deleteCredentials();
}

export default function* execute(): any {
  try {
    yield put({ type: Types.VALIDATE_USER_TOKEN_REQUEST });
    const keycloak = KeycloakManager.getInstance();
    const resultAuth = yield keycloak.login();
    if (!resultAuth?.authenticated) {
      yield put({
        type: Types.VALIDATE_USER_TOKEN_FAILURE,
        error: 'No se ha iniciado una sesión'
      });
    }
    const {
      token,
      refreshToken,
      isSimulator,
      isStudent,
      tokenParsed,
      isVisor
    } = resultAuth;
    // validating role
    if (!isSimulator && !isStudent && !isVisor) {
      yield put({
        type: Types.VALIDATE_USER_ROLE_FAILURE,
        error: 'No tiene roles activos'
      });
      return;
    }

    // validating token
    if (!token || !refreshToken) {
      yield put({
        type: Types.VALIDATE_USER_TOKEN_FAILURE,
        error: 'Los parámetros no son correctos'
      });
      return;
    }
    const profileRepository: ProfileRepository = new ProfileDataRepository();
    const profileResponse = yield call(profileRepository.getProfile);
    if (isSimulator || isVisor) {
      yield put({
        type: Types.VALIDATE_USER_TOKEN_SUCCESS,
        data: {
          isSimulator: isSimulator || isVisor,
          userName: tokenParsed.given_name,
          lastName: tokenParsed.family_name
        }
      });
      if (profileResponse) {
        const { career, plan, prog } = profileResponse.academic;
        const { id: period } = profileResponse.academic.period;
        yield put({
          type: 'GET_PROFILE_ACL',
          career,
          plan,
          prog,
          period: period.toString()
        });
      }
      return;
    }
    if (!profileResponse) {
      yield put({
        type: Types.VALIDATE_USER_ENROLLMENT_FAILURE,
        error: 'No se ha podido leer el profile'
      });
      return;
    }
    const { career, plan, prog } = profileResponse.academic;
    const { id: period } = profileResponse.academic.period;

    yield put({
      type: 'GET_PROFILE_ACL',
      career,
      plan,
      prog,
      period: period.toString()
    });
    yield put({
      type: TypesProfile.GET_PROFILE_SUCCESS,
      data: profileResponse
    });
    yield put({ type: 'GET_PERIODS' });
    yield put({ type: 'GET_STUDENT_PORTAL_SETTINGS' });
    yield put({
      type: Types.VALIDATE_USER_TOKEN_SUCCESS,
      data: {
        isSimulator: isSimulator || isVisor
      }
    });
  } catch (error) {
    yield put({
      type: Types.VALIDATE_USER_TOKEN_FAILURE,
      error: 'No se ha iniciado una sesión'
    });
    yield deleteCredentials();
  }
}
